import { Container } from "@mui/system";
import { Grid, Paper, Typography } from '@mui/material';
import globals from "../globals";
import BlueButton from "../components/blueButton";

const ErrorPayment = () => {
    return (
        <Container>
            <Grid container justifyContent={'center'} textAlign={'center'}>
                <Paper elevation={4} sx={{px:10, pb:3}}>
                    <Grid item>
                        <img src="failed_payment_page.webp" height={200} width={200}/>
                    </Grid>
                    <Grid item>
                        <Typography sx={{mt:2, color: globals.colors.lightRed,fontWeight: 'bold', fontSize: 25}}>Неуспешно плащане!</Typography>
                    </Grid>
                    <Grid item>
                        <Typography sx={{mt:2, color: globals.colors.darkBlue,fontWeight: 'bold', fontSize: 18}}>Плащането не беше успешно. Моля, опитай пак!</Typography>
                    </Grid>
                    <Grid item>
                        <BlueButton text={'Опитай пак'} sx={{px: 2, mt:2}}/>
                    </Grid>
                </Paper>
            </Grid>
        </Container>
    );
}

export default ErrorPayment;